import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Button, ButtonGroup, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { placeholders } from '../placeholders';

const useStyles = makeStyles(theme => ({
  placeholders: {
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(2),
    '& > *': {
      flex: 1,
      color: theme.palette.grey[600]
    }
  }
}));

export const getPlaceholderText = (field) => {
  return field.placeholder_text;
};

export const replacePlaceholder = (text) => {
  placeholders.forEach(placeholder => {
    text = text.replaceAll(`{${placeholder.field}}`, placeholder.placeholder_text);
  });

  return text;
};

const Placeholders = ({ setText, text }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const insertPlaceholderField = (field) => {
    const element = document.getElementById('text-form');
    const oldValue = element.value.trim();
    setText({ ...text, text: oldValue.length
      ? `${oldValue} ${field}`
      : field
    });
    element.focus();
  };

  const placeholderButtons = useMemo(() => placeholders.map((placeholder, index) => (
    <Button
      size="small"
      key={placeholder.field}
      onClick={() => insertPlaceholderField(`{${placeholder.field}}`)}>
      <Tooltip
        key={index}
        title={t(placeholder.button_text)}>
        {placeholder.icon}
      </Tooltip>
    </Button>
  )));

  return (
    <>
      <InputLabel shrink>Placeholders</InputLabel>
      <ButtonGroup
        className={classes.placeholders}
        variant="outlined"
        disableElevation>
        {placeholderButtons}
      </ButtonGroup>
    </>
  );

};


export default Placeholders;